module.exports = __webpack_public_path__ + "static/img/banner1.8dada8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/banner1.png
// module id = jJv1
// module chunks = 1